import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ActiveContext from "../../Context/Context";
import { useContext } from "react";

const ProcedureCheckboxList = ({ procedures, checkboxRefs }) => {
  const {t} = useTranslation();
  const { showAddForm } = useContext(ActiveContext);
  if (showAddForm) {
    return null;
  }
  return (
    <FormGroup>
      {procedures.map((procedure, index) => {
        let label = procedure.label;
        if (typeof procedure.label === "object") {
          label = label.name
        }
        return <FormControlLabel
          key={index}
          control={
            <Checkbox
              defaultChecked={procedure.value}
              inputRef={(ref) => (checkboxRefs.current[index] = ref)}
            />
          }
          label={t(label)}
        />
      })}
    </FormGroup>
  );
};

export default ProcedureCheckboxList;
